import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as referencesActions from '../../../redux/actions/ReferencesActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ReferencesTable from './ReferencesTable';
import ReferenceModal from './ReferenceModal';
import { PermissionTypes } from '../../../lib/systemVariables';
import { debounce } from 'throttle-debounce';

class ReferencesPage extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModals: {
                newReferenceModal: false
            }
        };
    }

    componentWillUnmount() {
        this.searchReferences('');
    }

    searchReferences = keyword => {
        this.props.actions.updateReferencesSearch(keyword);
        this.searchDebounce();
    }

    searchDebounce = debounce(500, () => {
        this.props.actions.getReferences(1, this.props.referencesTable.resultView, this.props.referencesTable.sort);
    });

    createReference = async reference => {
        await this.props.actions.createReference(reference);
        if (this.props.createReference.success) {
            this.props.actions.getReferences(1, this.props.referencesTable.resultView, this.props.referencesTable.sort);
        }
    }

    updateReference = async (referenceId, reference) => {
        await this.props.actions.updateReference(referenceId, reference);
        if (this.props.updateReference.success) {
            this.props.actions.getReferences(this.props.referencesTable.page, this.props.referencesTable.resultView, this.props.referencesTable.sort);
        }
    }

    render() {
        return (
            <div className="page references-page">
                <div className="subheader">
                    <div className="container flex-justify flex-center" style={{marginBottom: "32px"}}>
                        <h2 className="page-header">References</h2>
                        <div className="flex-center">
                            <div className="search-input">
                                <i className="material-icons">search</i>
                                <div>
                                <input type="text" placeholder="Search" value={this.props.keyword || ''}
                                    disabled={!this.props.keyword && !this.props.referencesTable.data.records.length}
                                    onChange={e => this.searchReferences(e.target.value)} />
                                </div>
                            </div>
                            {this.props.userPermissions.manage &&
                                <button className="btn btn-primary" onClick={() => this.toggleModal("newReferenceModal")}>New Reference</button>}
                        </div>
                    </div>
                </div>

                <ReferencesTable
                    canManage={this.props.userPermissions.manage}

                    {...this.props.referencesTable}
                    updateTable={this.props.actions.updateTable}
                    getReferences={this.props.actions.getReferences}

                    updatingReference={this.props.updateReference}
                    updateReference={this.updateReference}
                    deleteReference={this.props.actions.deleteReference}

                    usPersonTitles={this.props.usPersonTitles}
                    israelPersonTitles={this.props.israelPersonTitles}
                    usInstitutionTitles={this.props.usInstitutionTitles}
                    israelInstitutionTitles={this.props.israelInstitutionTitles}
                    recipientTypes={this.props.recipientTypes} />

                <ReferenceModal
                    show={this.state.showModals.newReferenceModal}
                    close={this.toggleModal.bind(this, "newReferenceModal")}
                    {...this.props.createReference}
                    submitReference={this.createReference}
                    usPersonTitles={this.props.usPersonTitles}
                    israelPersonTitles={this.props.israelPersonTitles}
                    usInstitutionTitles={this.props.usInstitutionTitles}
                    israelInstitutionTitles={this.props.israelInstitutionTitles}
                    recipientTypes={this.props.recipientTypes} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.references,
        referencesTable: state.referencesTable,
        usPersonTitles: state.settings.systemSettings.data.recipientSettings.usPersonTitles,
        israelPersonTitles: state.settings.systemSettings.data.recipientSettings.israelPersonTitles,
        usInstitutionTitles: state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,
        israelInstitutionTitles: state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,
        recipientTypes: state.settings.systemSettings.data.otherSettings.recipientTypes,
        userPermissions: {
            manage: state.userProfile.permissions.data.indexOf(PermissionTypes.RecipientAccntsManage) >= 0
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(referencesActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferencesPage);


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/references/ReferencesPage.jsx